<script>
  // [06/23] https://tailwindui.com/components/application-ui/feedback/alerts
  import HiXCircle from '../heroicons/HiXCircle.svelte';
  import HiExclamationCircle from '../heroicons/HiExclamationCircle.svelte';
  import HiCheckCircle from '../heroicons/HiCheckCircle.svelte';
  import HiInformationCircle from '../heroicons/HiInformationCircle.svelte';

  export let type;
  export let message;
  export let cssClass = undefined;
</script>

<div class="tailwind alert {cssClass || ''}">
  {#if type === 'danger'}
    <div class="rounded-md bg-red-50 dark:bg-neutral-700 px-3 py-2">
      <div class="flex">
        <div class="flex-shrink-0">
          <HiXCircle cssClass="h-5 w-5 text-red-400 dark:text-red-400" aria-hidden="true" />
        </div>

        <div class="ml-3">
          <p class="text-sm font-medium text-red-800 dark:text-red-200"> {message} </p>
        </div>
      </div>
    </div>
  {:else if type === 'warning'}
    <div class="rounded-md bg-yellow-50 dark:bg-neutral-700 px-3 py-2">
      <div class="flex">
        <div class="flex-shrink-0">
          <HiExclamationCircle cssClass="h-5 w-5 text-yellow-400 dark:text-yellow-400" aria-hidden="true" />
        </div>

        <div class="ml-3">
          <p class="text-sm font-medium text-yellow-800 dark:text-yellow-200"> {message} </p>
        </div>
      </div>
    </div>
  {:else if type === 'success'}
    <div class="rounded-md bg-green-50 dark:bg-neutral-700 px-3 py-2">
      <div class="flex">
        <div class="flex-shrink-0">
          <HiCheckCircle cssClass="h-5 w-5 text-green-400 dark:text-green-400" aria-hidden="true" />
        </div>

        <div class="ml-3">
          <p class="text-sm font-medium text-green-800 dark:text-green-200"> {message} </p>
        </div>
      </div>
    </div>
  {:else if type === 'info'}
    <div class="rounded-md bg-blue-50 dark:bg-neutral-700 px-3 py-2">
      <div class="flex">
        <div class="flex-shrink-0">
          <HiInformationCircle cssClass="h-5 w-5 text-blue-400 dark:text-blue-400" aria-hidden="true" />
        </div>

        <div class="ml-3">
          <p class="text-sm font-medium text-blue-800 dark:text-blue-200"> {message} </p>
        </div>
      </div>
    </div>
  {/if}
</div>
